export const mapStateToProps = (state: any) => ({
  orgs: state.mainReducer.orgs,
  selectedOrg: state.mainReducer.selectedOrg,
  orgUsersLoading: state.mainReducer.orgUsersLoading || false,
  orgUsers: state.mainReducer.orgUsers || [],
})
